module.exports = __webpack_public_path__ + "img/xsss.b4270d01.png";